// Lib
import React from 'react';
import { DetailedCellError, ErrorType } from 'hyperformula/es';

// Components
import Icon from '../../../components/icons/Icon';
import TooltipSource from '../../../components/tooltips/TooltipSource';

// Styles
import './CellFormulaErrorRenderer.scss';
import { useGroupTranslator } from "../../../components/i18n/GroupTranslationContext";

interface Props {
    cellError: DetailedCellError;
}

const trim = (str: string): string => {
    if (str.at(str.length - 1) === '.') return str.slice(0, -1);

    return str;
};

const CellFormulaErrorRenderer: React.FC<Props> = (props) => {
    const translate = useGroupTranslator<'elements', 'elementTypes.table'>();
    const { cellError } = props;
    const { message, value, type } = cellError;

    const customMessages: { [type: string]: string } = {
        [ErrorType.DIV_BY_ZERO]: translate('formula.errorDivByZero', "Numbers can't be divided by zero"),
        [ErrorType.CYCLE]: translate('formula.errorCircularReference', 'Circular reference detected'),
    };

    const tooltipText = message && message !== '' ? trim(message) : customMessages[type] || value;

    return (
        <div className="CellFormulaErrorRenderer">
            <TooltipSource
                enabled
                className="cell-formula-error-tooltip-source"
                tooltipText={
                    <div className="tooltip-cell-formula-error-content">
                        <Icon name="error-alert-round" />
                        {tooltipText}
                    </div>
                }
                pollPosition
                distance={10}
                delay={200}
                triggerOnMouseEnter
            >
                <Icon name="error-alert-round"></Icon>
            </TooltipSource>
        </div>
    );
};

export default CellFormulaErrorRenderer;
